import React from 'react';
export function General() {
  return <div data-id="element-2258">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2259">
        General Settings
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2260">
        Manage your account and application preferences
      </p>

      <div className="space-y-6" data-id="element-2261">
        {/* Company Information */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2262">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2263">
            Company Information
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-2264">
            <div data-id="element-2265">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2266">
                Company Name
              </label>
              <input type="text" placeholder="Enter company name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2267" />
            </div>
            <div data-id="element-2268">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2269">
                Industry
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2270">
                <option data-id="element-2271">Automotive</option>
                <option data-id="element-2272">Technology</option>
                <option data-id="element-2273">Retail</option>
              </select>
            </div>
          </div>
        </div>

        {/* Regional Settings */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2274">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2275">
            Regional Settings
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-2276">
            <div data-id="element-2277">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2278">
                Timezone
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2279">
                <option data-id="element-2280">Asia/Kolkata (IST)</option>
                <option data-id="element-2281">America/New_York (EST)</option>
                <option data-id="element-2282">Europe/London (GMT)</option>
              </select>
            </div>
            <div data-id="element-2283">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2284">
                Currency
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2285">
                <option data-id="element-2286">INR (₹)</option>
                <option data-id="element-2287">USD ($)</option>
                <option data-id="element-2288">EUR (€)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-2289">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-2290">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}